<script lang="ts">
    import {
        VpCloseIcon,
        VpSearchIcon,
    } from '@decathlon-experience/icons/svelte';

    import { trans } from '$assets/shop-translator.js';
    import Button from '$saga/components/Button.svelte';
    import Loader from '$saga/components/Loader.svelte';
    import { filtersContext } from '$saga/views/Search/store';

    let keywordsValue = $state('');
</script>

<div class="flex flex-col desktop:flex-row w-full items-center gap-m">
    <form
        id="homepage-keywords-form"
        action="/voyages"
        data-turbo={false}
        method="GET"
        class="flex gap-xs items-center bg-container-quiet rounded-full pl-m desktop:pl-xl pr-xs py-2xs desktop:py-s w-full flex-[3]"
    >
        <span><VpSearchIcon class="size-xl" /> </span>
        <input
            bind:value={keywordsValue}
            type="search"
            name="keywords"
            data-hybrid-search="true"
            placeholder={trans('search.bar.keywords')}
            class="w-full !border-none !p-0 bg-container-quiet focus:!ring-0"
        />
        <button
            type="button"
            hidden={keywordsValue === ''}
            aria-label={trans('search.bar.clear_keywords')}
            class="cursor-pointer"
            onclick={() => {
                keywordsValue = '';
            }}
        >
            <span><VpCloseIcon class="size-xl" /></span>
        </button>
    </form>
    <Button
        form="homepage-keywords-form"
        type="submit"
        data-turbo={false}
        class="w-full desktop:flex-1 normal-case"
        shape="rounded"
    >
        {#if $filtersContext.isSubmitting}
            <Loader class="w-xl h-xl" color="white" />
        {:else}
            {trans('search.bar.search')}
        {/if}
    </Button>
</div>
